export const config = _sys => {
  return {
    behaviors: {}
  };
};